import { useSidebarStore } from '../store/sidebarStore';

/**
 * Simple hook that provides manual sidebar control
 * No automatic behavior - you control when to open/close
 */
export const useSidebarControl = () => {
  const { isOpen, openSidebar, closeSidebar, toggleSidebar } =
    useSidebarStore();

  return {
    isOpen,
    openSidebar,
    closeSidebar,
    toggleSidebar,
  };
};
